import React, { useState, useEffect, createContext, useContext } from "react";
import { getAircraftList } from "../services/otsEventService";
import { useAuthentication } from "meportal/AuthenticationProvider";

 export type AircraftListContextType = {
    validAircraftList: any[];
  };

const AircraftListContext = createContext<AircraftListContextType | null>(null);

export const AircraftListProvider = ({ children }) => {
  const [validAircraftList, setValidAircraftList] = useState<any[]>([]);
  const { userData, getLatestAccessToken } = useAuthentication();

    useEffect(() => {
        async function getAircraftdata() {
            try{
                if(userData.access_token !== "") {
                    let validAircraftList: any[] = [];
                    const token = await getLatestAccessToken();
                    userData.access_token = token;
                    let response = await getAircraftList(userData);
                    if(response) {
                        validAircraftList = response.map((item) =>
                            removeStartingChar(item?.AircraftRegistration)
                        );
                        validAircraftList.sort((a, b) => a.localeCompare(b));
                    }
                    setValidAircraftList(validAircraftList);
                }
            }
            catch(error) {
                console.log("getAircraftList error: ", error);
            }
        }
            
        getAircraftdata();
    }, [userData]);

    function removeStartingChar(item: any) {
        if (item.charAt(0) === "N") {
          item = item.substring(1);
        }
        return item;
      }

    return (
        <AircraftListContext.Provider value={{ validAircraftList }}>
            {children}
        </AircraftListContext.Provider>
    );
}

// Custom hook that exposes the AircraftListContext
// Allows lower components to access AircraftListProvider's list of aircraft
export const useAircraftList = () => {
    const context = useContext(AircraftListContext);
    if (!context) {
      throw new Error(
        "useAircraftList must be used within a AircraftListProvider. Wrap a parent component in <AircraftListProvider> to fix this error."
      );
    }
    return context;
  };